import TYPES from './_actionTypes';

const initialState = {
  uploading: false,
  uploadError: null,

  currentJob: null,
  currentJobLoading: false,
  currentJobError: null,
};

const studentBulkUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.UPLOAD_REQUEST:
      return { ...state, uploading: true, uploadError: null };
    case TYPES.UPLOAD_SUCCESS:
      return { ...state, uploading: false, currentJob: action.payload };
    case TYPES.UPLOAD_FAILURE:
      return { ...state, uploading: false, uploadError: action.payload.error };

    case TYPES.FETCH_JOB_STATUS_REQUEST:
      return { ...state, currentJobLoading: true, currentJobError: null };
    case TYPES.FETCH_JOB_STATUS_SUCCESS:
      // Merge so upload-only fields (filename, created_at) survive the poll.
      return {
        ...state,
        currentJobLoading: false,
        currentJob: { ...state.currentJob, ...action.payload },
      };
    case TYPES.FETCH_JOB_STATUS_FAILURE:
      // Job no longer exists on the server (cleaned up) — drop it entirely.
      if (action.payload.status === 404) return { ...initialState };
      return { ...state, currentJobLoading: false, currentJobError: action.payload.error };

    case TYPES.CLEAR_CURRENT_JOB:
      return { ...state, currentJob: null, currentJobError: null, uploadError: null };

    default:
      return state;
  }
};

export default studentBulkUploadReducer;
